"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.anyCalc = anyCalc;
exports.anyDisabled = anyDisabled;
exports.wrapSchemaProps = wrapSchemaProps;
exports.wrapSchemaProp = wrapSchemaProp;
exports.wrapWarningProps = wrapWarningProps;
exports.wrapWarningProp = wrapWarningProp;
exports.initCtx = initCtx;
exports.createCtxProxy = createCtxProxy;
exports.debounceRun = debounceRun;
exports.isPromise = isPromise;
exports.isWrappedProperty = isWrappedProperty;
exports.runEvent = runEvent;
exports.addEvent = addEvent;
exports.removeEvent = removeEvent;
exports.logError = logError;
exports.logWarning = logWarning;
const vue_1 = require("vue");
const defineSchema_1 = require("../JSchema/defineSchema");
const validPropFunction_1 = require("../JSchema/validPropFunction");
/**
 * sprawdza czy element lub podrzędne ma wyliczenia
 *
 * @export
 * @param {*} schema
 * @returns {boolean}
 */
function anyCalc(schema) {
    if (schema._anyCalc !== undefined) {
        return schema._anyCalc;
    }
    if (schema.calc || schema.summary || schema.aggregate) {
        Object.defineProperty(schema, '_anyCalc', {
            value: true
        });
        return true;
    }
    else if (schema.properties) {
        for (const key in schema.properties) {
            const isCalc = anyCalc(schema.properties[key]);
            if (isCalc) {
                Object.defineProperty(schema, '_anyCalc', {
                    value: true
                });
                return true;
            }
        }
    }
    else if (schema.items) {
        return anyCalc(schema.items);
    }
    Object.defineProperty(schema, '_anyCalc', {
        value: false
    });
    return false;
}
/**
 * sprawdza czy element lub nadrzędny jest wyłączony
 *
 * @export
 * @param {IWrappedProperty} obj
 * @returns {boolean}
 */
function anyDisabled(obj) {
    return !!(obj.$schema.disabled || (obj.$parent && anyDisabled(obj.$parent)) || false);
}
/**
 * hurtowe obudowanie dynamicznych pól schematu
 *
 * @export
 * @param {*} $schema schemat wyliczony
 * @param {IInternal} internal zmienne wewnętrzne obiektu
 * @param {string} type jeśłi pole schematu nie jest tego typu to znaczy że jest wyliczeniowe
 * @param {string[]} props jakie własciwości schematu obudować
 */
function wrapSchemaProps(prop, internal, type, props) {
    // tslint:disable-next-line: prefer-for-of
    const $schema = prop.$schema;
    for (let i = 0; i < props.length; i++) {
        const field = props[i];
        if (internal.schema[field] !== undefined) {
            if (typeof internal.schema[field] !== type) {
                wrapSchemaProp(prop, field, internal);
            }
            else {
                $schema[field] = internal.schema[field];
            }
        }
    }
}
/**
 * obudowanie pojedyńczej własciwości schematu
 *
 * @export
 * @param {*} $schema schemat decelowy
 * @param {string} field nazwa pola
 * @param {IInternal} internal zmienne wewnętrzne obiektu
 * @param {*} [func] callback wywoływany w przypadku zmiany wartości
 * @returns
 */
function wrapSchemaProp(prop, field, internal, func) {
    const schema = internal.schema;
    //if (!internal.calcargs)
    //  initVue(prop, internal)
    const v = schema[field];
    const $schema = prop.$schema;
    delete $schema[field];
    // if (self.isSimpleField(v)) {
    let ff;
    //let thisModel: any;
    if (!internal.calcCtx)
        initCtx(prop, internal);
    if ((0, defineSchema_1.isFunction)(v)) {
        ff = v;
        if (!internal.thisModel)
            internal.thisModel = createCtxProxy(internal);
    }
    else {
        if (internal.funcCache) {
            if (schema.__cache === undefined) {
                Object.defineProperty(schema, '__cache', {
                    value: {}
                });
            }
            ff = schema.__cache[`schema_${field}`];
        }
        if (ff === undefined) {
            ff = (0, validPropFunction_1.validPropFunction)(v);
            if (internal.funcCache)
                schema.__cache[`schema_${field}`] = ff;
        }
    }
    //let nvalue: any;
    const cvalue = (0, vue_1.computed)(() => {
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        internal.options._forceRecalc && internal.options._forceRecalc;
        //let result = ff.apply(internal.parent, internal.calcargs);
        try {
            const result = ff.call(internal.thisModel || internal.parent, internal.calcCtx);
            return result;
        }
        catch (err) {
            logError(prop, `get schema.${field}`, err, v);
            return undefined;
        }
    });
    if (func) {
        let nvalue = null;
        const watchStop = (0, vue_1.watchEffect)(() => {
            try {
                nvalue = ff.call(internal.thisModel || internal.parent, internal.calcCtx);
                // nvalue = ff.apply(internal.parent, internal.calcargs);
                func(nvalue);
            }
            catch (err) {
                logError(prop, `get schema.${field}`, err, v);
                return undefined;
            }
        }, {
            flush: 'post'
        });
        internal.watchStops.push(watchStop);
    }
    // delete $schema[field];
    Object.defineProperty($schema, field, {
        enumerable: true,
        get() {
            return cvalue.value;
        }
    });
}
/**
 * hurtowe obudowanie dynamicznych pól schematu dotyczących ostrzeżeń
 *
 * @export
 * @param {*} $schema schemat wyliczony
 * @param {IInternal} internal zmienne wewnętrzne obiektu
 * @param {string} type jeśłi pole schematu nie jest tego typu to znaczy że jest wyliczeniowe
 * @param {string[]} props jakie własciwości schematu obudować
 */
function wrapWarningProps(prop, internal, type, props) {
    const wr = internal.schema.warnings || {};
    const $schema = prop.$schema;
    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < props.length; i++) {
        const field = props[i];
        if (wr[field] !== undefined) {
            if (typeof wr[field] !== type) {
                wrapWarningProp(prop, field, internal);
            }
            else if ($schema.warnings) {
                $schema.warnings[field] = wr[field];
            }
        }
    }
}
/**
 * obudowanie pojedyńczej własciwości schematu dotyczącego ostrzeżeń
 *
 * @export
 * @param {*} $schema schemat decelowy
 * @param {string} field nazwa pola
 * @param {IInternal} internal zmienne wewnętrzne obiektu
 * @param {*} [func] callback wywoływany w przypadku zmiany wartości
 * @returns
 */
function wrapWarningProp(prop, field, internal, func) {
    const schema = internal.schema;
    const v = schema.warnings[field];
    const $schema = prop.$schema;
    if ($schema.warnings) {
        delete $schema.warnings[field];
    }
    if (!internal.calcCtx) {
        initCtx(prop, internal);
    }
    let ff;
    //let thisModel: any;
    if ((0, defineSchema_1.isFunction)(v)) {
        ff = v;
        if (!internal.thisModel)
            internal.thisModel = createCtxProxy(internal);
    }
    else {
        if (internal.funcCache) {
            if (schema.__cache === undefined) {
                Object.defineProperty(schema, '__cache', {
                    value: {}
                });
            }
            ff = schema.__cache[`schema_warnings_${field}`];
        }
        if (ff === undefined) {
            ff = (0, validPropFunction_1.validPropFunction)(v);
            if (internal.funcCache)
                schema.__cache[`schema_warnings_${field}`] = ff;
        }
        //thisModel = internal.parent;
    }
    const fcomputed = (0, vue_1.computed)(() => {
        try {
            return ff.call(internal.thisModel || internal.parent, internal.calcCtx);
        }
        catch (err) {
            logError(prop, `get schema.warnings.${field}`, err, v);
            return undefined;
        }
    });
    if (func) {
        let nvalue = null;
        const watchStop = (0, vue_1.watchEffect)(() => {
            try {
                nvalue = ff.call(internal.thisModel || internal.parent, internal.calcCtx);
                func(nvalue);
            }
            catch (err) {
                logError(prop, `get schema.warnings.${field}`, err, v);
                return undefined;
            }
        }, {
            flush: 'post'
        });
        internal.watchStops.push(watchStop);
    }
    Object.defineProperty($schema.warnings, field, {
        enumerable: true,
        get() {
            return fcomputed.value;
        }
    });
}
/**
 * inicjalizacja wewnętrznego obiektu Vue
 *
 * @export
 * @param {IWrappedProperty} prop do którego obiektu jest tworzony
 * @param {IInternal} internal dane wewnętrzne obiektu
 * @returns {*}
 */
/*
export function initVue(prop: IWrappedProperty, internal: IInternal): any {
  // if (internal.needsCalcArgs) {
  if (!internal.calcargs)
    internal.calcargs = [];
  if (internal.options.external) {
    internal.calcargs[4] = internal.options.external;
    // console.log('set external', self.external);
  } else {
    internal.calcargs[4] = {};
  }
  internal.calcargs[5] = internal.options.schemaMethods;
  internal.calcargs[6] = prop;

  internal.calcargs[0] = prop.$root.$model;
  const dest = prop.$parent;
  if (dest && dest.$parent) {
    internal.calcargs[1] = dest.$parent.$model;
    if (dest.$parent.$parent) {
      internal.calcargs[2] = dest.$parent.$parent.$model;
      if (dest.$parent.$parent.$parent) {
        internal.calcargs[3] = dest.$parent.$parent.$parent.$model;
      } else {
        internal.calcargs[3] = {};
      }
    } else {
      internal.calcargs[2] = internal.calcargs[3] = {};
    }
  } else {
    internal.calcargs[1] = internal.calcargs[2] = internal.calcargs[3] = {};
  }


}
*/
/**
 * inicjalizacja wewnętrznego obiektu Vue
 *
 * @export
 * @param {IWrappedProperty} prop do którego obiektu jest tworzony
 * @param {IInternal} internal dane wewnętrzne obiektu
 * @returns {*}
 */
function initCtx(prop, internal) {
    // if (internal.needsCalcArgs) {
    if (!internal.calcCtx)
        internal.calcCtx = {};
    if (internal.options.external) {
        internal.calcCtx.$external = internal.options.external;
        // console.log('set external', self.external);
    }
    else {
        internal.calcCtx.$external = {};
    }
    internal.calcCtx.$methods = internal.options.schemaMethods;
    internal.calcCtx.$obj = prop;
    internal.calcCtx.$root = prop.$root.$model;
    const dest = prop.$parent;
    if (dest && dest.$parent) {
        internal.calcCtx.$parent = dest.$parent.$model;
        if (dest.$parent.$parent) {
            internal.calcCtx.$parent2 = dest.$parent.$parent.$model;
            if (dest.$parent.$parent.$parent) {
                internal.calcCtx.$parent3 = dest.$parent.$parent.$parent.$model;
            }
            else {
                internal.calcCtx.$parent3 = {};
            }
        }
        else {
            internal.calcCtx.$parent2 = internal.calcCtx.$parent3 = {};
        }
    }
    else {
        internal.calcCtx.$parent = internal.calcCtx.$parent2 = internal.calcCtx.$parent3 = {};
    }
    return internal.calcCtx;
}
function createCtxProxy(internal) {
    var _a;
    if ((_a = internal.options) === null || _a === void 0 ? void 0 : _a.simpleThis)
        return undefined;
    return new Proxy(internal.calcCtx, {
        get(target, prop, reciver) {
            switch (prop) {
                case '$root':
                    return target.$root;
                case '$methods':
                    return target.$methods;
                case '$external':
                    return target.$external;
                case '$obj':
                    return target.$obj;
                case '$parent':
                    return target.$parent;
                case '$parent2':
                    return target.$parent2;
                case '$parent3':
                    return target.$parent3;
                case '$event':
                    return target.$event;
                case '$value':
                    return target.$value;
                case '$this':
                    return internal.parent;
            }
            return Reflect.get(internal.parent, prop, reciver);
        },
        set(target, prop, newValue /*, receiver*/) {
            if (prop && typeof prop === 'string' && prop.startsWith('$'))
                return false;
            return Reflect.set(internal.parent, prop, newValue);
        }
    });
}
function debounceRun(internal, value, func) {
    if (internal.debounce) {
        if (internal.debounceValue) {
            internal.debounceValue.value = value;
        }
        clearTimeout(internal.debounceTimer);
        internal.debounceTimer = setTimeout(() => {
            if (internal.debounceValue) {
                internal.debounceValue.value = undefined;
            }
            func();
        }, internal.debounce);
    }
    else {
        func();
    }
}
function isPromise(p) {
    if (typeof p === 'object' && typeof p.then === 'function') {
        return true;
    }
    return false;
}
function isWrappedProperty(obj) {
    return obj && obj._internal && obj._options && obj.$root;
}
function runEvent(event, obj) {
    obj = obj || event.target;
    let ctx = obj._internal.calcCtx;
    if (!obj._options._anyEvent)
        return false;
    if (!event.path && obj) {
        event.path = obj.$path;
    }
    let result = false;
    const internal = obj._internal;
    if (internal.on) {
        const eventSet = internal.on[event.type];
        if (eventSet && eventSet.size) {
            event.$obj = obj;
            for (const eventFunc of eventSet) {
                //if (eventFunc.length > 1 && !ctx) {
                if (!ctx) {
                    //potrzeba ctx
                    ctx = initCtx(obj, obj._internal);
                }
                ctx.$event = event;
                try {
                    eventFunc.call(obj._internal.thisModel || obj._internal.parent || obj.$model, event, ctx);
                }
                catch (err) {
                    logError(obj, `run event: ${event.type}`, err, eventFunc);
                }
                result = true;
            }
        }
    }
    if (obj.$parent && !event.stopPropagate) {
        if (runEvent(event, obj.$parent)) {
            result = true;
        }
    }
    return result;
}
function addEvent(obj, eventName, eventFunction) {
    // const result = false;
    const internal = obj._internal;
    if (!internal.on) {
        internal.on = {};
    }
    if (!internal.on[eventName]) {
        internal.on[eventName] = new Set();
    }
    internal.on[eventName].add(eventFunction);
    obj._options._anyEvent[eventName] = true;
    return true;
}
function removeEvent(obj, eventName, eventFunction) {
    const internal = obj._internal;
    if (!internal.on) {
        return false;
    }
    if (!eventName) {
        internal.on = undefined;
        return true;
    }
    if (!internal.on[eventName]) {
        return false;
    }
    if (eventFunction) {
        return internal.on[eventName].delete(eventFunction);
    }
    else {
        internal.on[eventName].clear();
        delete internal.on[eventName];
        return true;
    }
}
/**
 * logowanie błędów
 * @param obj wrapperd property
 * @param info zrodlo bledu
 * @param err obiekt błedu
 * @param func zrodło błedu
 */
function logError(obj, info, err, func) {
    var _a;
    if ((_a = obj._options) === null || _a === void 0 ? void 0 : _a.logErrors)
        console.error(`[DEBUG] ERR ${info}`, obj.toString(), err.message || err, func.toString());
}
/**
 * logowanie warningów
 * @param obj wrapperd property
 * @param info zrodlo bledu
 * @param func zrodło błedu
 */
function logWarning(obj, info, func) {
    var _a;
    if ((_a = obj._options) === null || _a === void 0 ? void 0 : _a.logWarnings)
        console.warn(`[DEBUG] WARN ${info}`, obj.toString(), func.toString());
}
//# sourceMappingURL=functions.js.map